import { useGetProjectInvoices } from '@/api/queries/project/useGetProjectInvoices';
import { useDeal, useProposalsForDeal } from '@payaca/store/hooks/appState';
import { FC } from 'react';
import { InvoiceCard } from '../invoiceCard/InvoiceCard';
import ProtoInvoiceCard from '../invoiceCard/ProtoInvoiceCard';
import { InvoicesEmptyState } from './InvoicesEmptyState';

export const ListedInvoices: FC<{
  projectId: number;
  onRecordPaymentSuccess?: () => void;
}> = ({ projectId, onRecordPaymentSuccess }) => {
  const proposals = useProposalsForDeal(projectId);
  const protoInvoice = proposals?.find(
    (p) => p.isProtoInvoice && !p.inactivatedAt && !p.archivedAt && !p.sentAt
  );
  const deal = useDeal(projectId);

  const { data: invoices } = useGetProjectInvoices(deal?.publicId);

  const isEmpty = !(!!invoices?.length || protoInvoice);
  return (
    <div>
      {isEmpty && <InvoicesEmptyState />}
      {!isEmpty && (
        <ul className="list-none p-0 m-0 space-y-4">
          {protoInvoice && (
            <li>
              <ProtoInvoiceCard protoInvoiceId={protoInvoice.id} />
            </li>
          )}
          {invoices?.map((invoice, i) => {
            return (
              <li key={i}>
                <InvoiceCard
                  onRecordPaymentSuccess={onRecordPaymentSuccess}
                  invoice={invoice}
                />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
